export var STEP_SIZES;
(function (STEP_SIZES) {
    STEP_SIZES["lg"] = "lg";
    STEP_SIZES["md"] = "md";
    STEP_SIZES["sm"] = "sm";
})(STEP_SIZES || (STEP_SIZES = {}));
export var STEP_TYPES;
(function (STEP_TYPES) {
    STEP_TYPES["number"] = "number";
    STEP_TYPES["icon"] = "icon";
    STEP_TYPES["bar"] = "bar";
})(STEP_TYPES || (STEP_TYPES = {}));
export var propsToNotForward = ['src'];
